import { serviceProducts } from './serviceProducts';
import { mainServiceGroups } from './mainServices';

// Catégorie produit statique → service parent (slug services.json)
export const PARENT_BY_CATEGORY = {
  civil: 'personal',
  academic: 'academic',
  criminal: 'administrative',
  driving: 'administrative',
  financial: 'financial',
  business: 'commercialDocs',
  legalMedical: 'legalDocs',
  addons: 'certified',
};

// Catégorie → filtres sous lesquels le service apparaît (slugs services.json)
export const FILTERS_BY_CATEGORY = {
  civil: ['personal', 'administrative', 'certified', 'sworn', 'general'],
  academic: ['academic', 'certified', 'sworn', 'general'],
  criminal: ['administrative', 'personal', 'certified', 'sworn'],
  driving: ['personal', 'administrative', 'certified', 'general'],
  financial: ['financial', 'commercial', 'commercialDocs', 'specialized'],
  business: ['commercialDocs', 'commercial', 'legalDocs', 'legal', 'specialized'],
  legalMedical: ['legalDocs', 'legal', 'certified', 'sworn', 'specialized'],
  addons: ['certified', 'legalization', 'administrative'],
};

// Filtres supplémentaires par produit précis
export const EXTRA_FILTERS = {
  medicalCert: ['medical', 'medicalDocs'],
  vaccination: ['medical', 'medicalDocs'],
  apostilleDoc: ['apostille', 'legalization'],
  signatureLegalization: ['legalization', 'apostille'],
  commercialTranslation: ['commercial'],
  marketingAdvertising: ['marketing'],
  technicalWebsite: ['technical'],
  tourismGuide: ['tourism'],
  academicScientific: ['academic', 'specialized'],
};

const PRODUCT_BY_SLUG = new Map(serviceProducts.map((p) => [p.slug, p]));

const lc = (v) => String(v || '').toLowerCase();

// Filtres applicables à un enregistrement DB (slug/type) ou un produit local.
// Tout est normalisé en minuscules (le schéma MongoDB force `tags` en lowercase).
export function filterTypesFor(product) {
  const prod = PRODUCT_BY_SLUG.get(product.slug || product.id) || product;
  const set = new Set((FILTERS_BY_CATEGORY[prod.category] || []).map(lc));
  (EXTRA_FILTERS[prod.id] || []).forEach((f) => set.add(lc(f)));
  if (product.filterType || product.type) set.add(lc(product.filterType || product.type));
  (product.tags || []).forEach((t) => t && set.add(lc(t)));
  return [...set];
}

// Slugs « Type de traduction » (groupes professional + official du services.json)
export const TRANSLATION_SLUGS = new Set(
  mainServiceGroups.filter((g) => g.id !== 'documents').flatMap((g) => g.services.map((s) => lc(s.slug))),
);

// Slugs « Type de document » (groupe documents du services.json)
export const DOCUMENT_SLUGS = new Set(
  (mainServiceGroups.find((g) => g.id === 'documents')?.services || []).map((s) => lc(s.slug)),
);
